<template>
  <div class="bbp-filter-popup">
    <BBPSelectImage
      :options="options"
      label="username"
      :value="value"
      :isSelectUserFilter="true"
      @change="onChange"
    />
  </div>
</template>

<script>

import BBPSelectImage from '@/components/Main/InputFields/BBPSelectImage/BBPSelectImage'
import {groupBy, orderBy} from 'lodash'

export default {
  name: 'BBPFilterPopup',
  props: {
    column: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    value: null
  }),
  components: {
    BBPSelectImage
  },
  computed: {
    options () {
      const { options = [] } = this.column
      const sortedUsers = orderBy(options, ['username'], ['asc'])
      const groupUsers = groupBy(sortedUsers, 'isNotAssigned')
      const isNotAssigned = groupUsers.true || []
      const usersSorted = orderBy(groupUsers.false, [item => item.username.toLowerCase()], ['asc'])
      return [...usersSorted, ...isNotAssigned]
    }
  },
  methods: {
    onChange (value) {
      if (this.value && this.value._id === value._id) {
        this.value = {}
        this.$emit('onChangeFilter', this.column, {})
      } else {
        this.value = value
        this.$emit('onChangeFilter', this.column, value)
      }
    },
    setDefaultValue () {
      const currentItem = this.options.find((el) => el.isActive)
      this.value = currentItem
    }
  },
  beforeMount () {
    this.setDefaultValue()
  }
}
</script>

<style lang="scss" scoped>

  .bbp-filter-popup {
    position: relative;
  }
</style>

<style lang="scss">

  .bbp-filter-popup {
    .bb-loader-select-header {
      position: absolute !important;
      top: -50%;
      transform: translateY(-50%);
      height: 30px !important;
      left: -80px;
      width: 80px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPFilterPopup/BBPFilterPopup.vue